export const JUMIO = 'jumio';

export const JUMIO_HAVE_COPY_ID_FAX_KEY = 145;

export const JUMIO_HAVE_COPY_ID_FAX_VALUE = {
    VERIFIED: '1'
    // NOT_VERIFIED: '0'
};

export const ICON_TYPE_TO_STATUS_MAP = {
    pending: 'pending',
    verified: 'success',
    notVerified: 'attention'
};

export const JUMIO_TAG_NAME = 'risk/doc/upload_requirement';

export const JUMIO_VERIFICATION_STATUS = {
    VERIFIED: 'verified',
    PENDING: 'pending',
    NOT_VERIFIED: 'notVerified'
};

export const BENEFICIAL_ACCOUNT_CONFIRMATION_TAG = 'sc/verification/beneficialAccountConfirmation';

export const BENEFICIAL_OWNER_CONFIRM = 'playtech.mobile.system.beneficialOwner.confirm';

export const TAG_NAMES = [
    'risk/doc/upload_requirement',
    'risk/doc/upload_requirement_additional',
    'risk/doc/status',
    'risk/doc/status_additional'
];

export const ICON_TYPES = {
    approved: 'success',
    failed: 'error',
    pending: 'pending',
    empty: 'attention'
};
